<label [for]="id" [ngClass]="['control-label', _labelClass]">Antenne</label>
<div [ngClass]="_fieldClass">
	<extended-filterable-select
		[id]="id"
		[list]="antennes"
		[inputClass]="'form-control'"
		[disabled]="disabled"
		[labelGetter]="getAntenneLabel"
		[selectedItem]="selectedAntenne"
		(selectedItemChange)="onSelectedAntenneChange($event)"
		>
	</extended-filterable-select>
</div>